module.exports = __webpack_public_path__ + "static/media/inactiveSalaryDownload.cff2f591.svg";